import React from 'react'

export const TickFilledIcon = ({ color: _color = {}, ...rest }) => {
  const color = { background: '#AC0AE8', strokes: 'white', ..._color }

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="32" height="32" rx="16" fill={color.background} />
      <path
        d="M10.166 16.7778L13.3327 21.0001"
        stroke={color.strokes}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.832 11.5L13.332 21"
        stroke={color.strokes}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
